/* Added the following code for secure.ray using AI Agent. 23/07/2026. Code Start */
/**
 * Attach JWT Authorization to /video-url and /subtitle-url fetches.
 * Covers the many lesson components that call fetch() without headers,
 * so media endpoints can require auth without rewriting every page.
 */
(function installSecureMediaFetch() {
  if (typeof window === "undefined" || window.__selftrainaiSecureMediaFetch) {
    return;
  }
  window.__selftrainaiSecureMediaFetch = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const url =
      typeof input === "string"
        ? input
        : input && typeof input.url === "string"
          ? input.url
          : "";

    if (url.includes("/video-url/") || url.includes("/subtitle-url/")) {
      const token = localStorage.getItem("token");
      const headers = new Headers(
        (init && init.headers) ||
          (typeof input !== "string" && input && input.headers) ||
          undefined
      );
      if (token && !headers.has("Authorization")) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return originalFetch(input, { ...init, headers });
    }

    return originalFetch(input, init);
  };
})();
/* Code end. ray using AI Agent. 23/07/2026 */
